import { Box, Flex, ListItem, UnorderedList } from '@chakra-ui/react'
import React from 'react'

const State2 = () => {
    return (
        <Box>

            <Flex justifyContent={"space-between"}>
                <Box>

                {/* Omega Fatty Acids
Omega 3
Fish Oil
Flaxseed Oil
Cod Liver Oil
Krill Oil */}
                    <UnorderedList listStyleType={"none"} w={"100%"}>
                        <ListItem p={"4%"} fontWeight={"700"}>Omega Fatty Acids</ListItem>
                        <ListItem p={"4%"}> </ListItem>
                        <ListItem p={"4%"}>Omega 3</ListItem>
                        <ListItem p={"4%"}>Fish Oil</ListItem>
                        <ListItem p={"4%"}>Flaxseed Oil</ListItem>
                        <ListItem p={"4%"}>Cod Liver Oil</ListItem>
                        <ListItem p={"4%"}>Krill Oil</ListItem>
                        
                    </UnorderedList>
                </Box>


                {/* Multivitamins
Multivitamins - Men
Multivitamins - Women
Multivitamins - General
Multivitamins - Children */}


                <Box>
                    <UnorderedList listStyleType={"none"} w={"100%"}>
                        <ListItem p={"4%"} fontWeight={"700"}>Multivitamins</ListItem>
                        <ListItem p={"4%"}> </ListItem>
                        <ListItem p={"4%"}>Multivitamins - Men</ListItem>
                        <ListItem p={"4%"}>Multivitamins - Women</ListItem>
                        <ListItem p={"4%"}>Multivitamins - Children</ListItem>

                    </UnorderedList>
                </Box>
                

                {/* Speciality Supplements
Immunity Supplements
Probiotics
Collagen
Fat Loss Supplements
Performance
Glucosamine Supplements
L-Arginine
Forskolin
Other Supplements
Personal Wellness
CLA */}




                <Box>
                    <UnorderedList listStyleType={"none"} w={"100%"}>
                        <ListItem p={"4%"} fontWeight={"700"}>Speciality Supplements</ListItem>
                        <ListItem p={"4%"}> </ListItem>
                        <ListItem p={"4%"}>Immunity Supplements</ListItem>
                        <ListItem p={"4%"}>Probiotics</ListItem>
                        <ListItem p={"4%"}>Collagen</ListItem>
                        <ListItem p={"4%"}>Fat Loss Supplements</ListItem>
                        <ListItem p={"4%"}>Performance</ListItem>
                        <ListItem p={"4%"}>Glucosamine Supplements</ListItem>
                        <ListItem p={"4%"}>L-Arginine</ListItem>
                        <ListItem p={"4%"}>Forskolin</ListItem>
                        <ListItem p={"4%"}>Other Supplements</ListItem>
                        <ListItem p={"4%"}>Personal Wellness</ListItem>
                        <ListItem p={"4%"}>CLA</ListItem>
                        {/* <ListItem p={"4%"}>Soy Proteins</ListItem> */}
                    </UnorderedList>
                </Box>


                {/* Vitamins
Vitamin C
Biotin
Vitamin B
Vitamin B Complex with B12
Vitamin D
Vitamin A
Vitamin K
Vitamin E */}
                

                <Box>
                    <UnorderedList listStyleType={"none"} w={"100%"}>
                        <ListItem p={"4%"} fontWeight={"700"}>Vitamins</ListItem>
                        <ListItem p={"4%"}> </ListItem>
                        <ListItem p={"4%"}>Vitamin C</ListItem>
                        <ListItem p={"4%"}>Biotin</ListItem>
                        <ListItem p={"4%"}>Vitamin B</ListItem>
                        <ListItem p={"4%"}>Vitamin B Complex with B12</ListItem>
                        <ListItem p={"4%"}>Vitamin D</ListItem>
                        <ListItem p={"4%"}>Vitamin A</ListItem>
                        <ListItem p={"4%"}>Vitamin K</ListItem>
                        <ListItem p={"4%"}>Vitamin E</ListItem>
                        {/* <ListItem p={"4%"}>Other Supports</ListItem> */}
                    </UnorderedList>
                </Box>


                




                <Box>
                    <UnorderedList listStyleType={"none"} w={"100%"}>
                        <ListItem p={"4%"} fontWeight={"700"}> Minerals</ListItem>
                        <ListItem p={"4%"}> </ListItem>
                        <ListItem p={"4%"}>Calcium</ListItem>
                        <ListItem p={"4%"}>Magnesium</ListItem>
                        <ListItem p={"4%"}>Iron</ListItem>
                        <ListItem p={"4%"}>Chromium</ListItem>
                        <ListItem p={"4%"}>Selenium</ListItem>
                        <ListItem p={"4%"}>Zinc</ListItem>

                    </UnorderedList>
                </Box>
            </Flex>

        </Box>
    )
}

export default State2
